import React from 'react';
import { useTranslation } from 'react-i18next';

import ErrorIcon from '@mui/icons-material/Error';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import EmptySectionCard from '../../Site/components/EmptySectionCard';

interface ErrorComponentProps {
  onRetry: () => void;
  errorMessage: string;
}

const ErrorComponent: React.FC<ErrorComponentProps> = ({
  onRetry,
  errorMessage,
}) => {
  const theme = useTheme();
  const { t } = useTranslation('hosting', { keyPrefix: 'hostingNova' });
  return (
    <Card sx={{ mt: 3 }}>
      <CardContent sx={{ px: 3 }}>
        <EmptySectionCard>
          <IconButton disableRipple sx={{ mb: 2 }}>
            <ErrorIcon
              sx={{ color: theme.palette.error.main }}
              fontSize="large"
            />
          </IconButton>
          <Typography variant="body1" mb={1}>
            {errorMessage}
          </Typography>
          <Button variant="outlined" onClick={onRetry} sx={{ mt: 2 }}>
            {t('retryBtn')}
          </Button>
        </EmptySectionCard>
      </CardContent>
    </Card>
  );
};

export default ErrorComponent;
